// This is the componenet which is resposible for rendering each row

import { FaTrash } from 'react-icons/fa';
import { useMutation } from '@apollo/client';
import { DELETE_CLIENT } from '../mutations/clientMutations';
// import { GET_CLIENTS } from '../queries/clientQueries';
// import { GET_PROJECTS } from '../queries/projectQueries';


export default function ClientRow({ client }) {
  const [deleteClient] = useMutation(DELETE_CLIENT, {
    variables: { id: client.id },
    // refetchQueries: [{query: GET_CLIENTS}, {query: GET_PROJECTS}],
    // reloading page (even though its a bad practice and we should reload each component)
    onCompleted: () => {
      window.location.reload();
    },
  });


  return (
    <tr>
      <td>{client.name}</td>
      <td>{client.email}</td>
      <td>{client.phone}</td>
      <td>
        <button className="btn btn-danger btn-sm"
          onClick={deleteClient}>
          <FaTrash />
        </button>
      </td>
    </tr>
  )
}
